const instructions = {
  state: [
    {
      title: 'Connect Your Wallet',
      text: 'Use your Metamask to interact with the Good Game Platform.',
      src: require('@/assets/img/wallet_icon_money.png'),
      bg: require('@/assets/img/img20.png'),
      num: 1,
    },
    {
      title: 'Join or Create',
      text: 'Join or create a bet on your favourite team.',
      src: require('@/assets/img/connect_icon.png'),
      bg: require('@/assets/img/img20.png'),
      num: 2,
    },
    {
      title: 'Cheer',
      text: 'Check the results in our oracle and collect spoils.',
      src: require('@/assets/img/confetti2.png'),
      bg: require('@/assets/img/img20.png'),
      num: 3,
    },
  ],
}
export default instructions
